import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';
import { ROLE_LABELS } from './shared.js';

export default function InviteModal({ onClose, onInvite }) {
  const { theme } = useTheme();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('editor');
  const [inviting, setInviting] = useState(false);
  const [error, setError] = useState('');

  const handleInvite = async () => {
    if (!email.trim()) { setError('Email is required'); return; }
    setInviting(true);
    setError('');
    try {
      await onInvite({ email: email.trim(), name: name.trim() || undefined, role });
      onClose();
    } catch (err) {
      setError(err.data?.error || err.message || 'Failed to invite user');
    } finally {
      setInviting(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: theme.overlay,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div onClick={e => e.stopPropagation()} style={{
        width: 420, padding: 28,
        background: theme.bg, border: `2px solid ${theme.text}`,
      }}>
        <h3 style={{ fontFamily: "'Aeonik', Arial, Helvetica, sans-serif", fontWeight: 450, margin: '0 0 20px', fontSize: 20, color: theme.text }}>invite team member</h3>

        {error && (
          <div style={{ padding: '8px 12px', marginBottom: 16, border: `1px solid ${theme.redBorder}`, color: theme.red, fontSize: 12 }}>{error}</div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 6 }}>email *</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="colleague@riester.com" autoFocus
            style={{ width: '100%', height: 40, padding: '0 12px', background: 'transparent', border: `1px solid ${theme.borderMedium}`, borderRadius: 0, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 6 }}>name</label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="full name (optional)"
            style={{ width: '100%', height: 40, padding: '0 12px', background: 'transparent', border: `1px solid ${theme.borderMedium}`, borderRadius: 0, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: theme.textFaint, marginBottom: 6 }}>role</label>
          <div style={{ display: 'flex', gap: 6 }}>
            {['viewer', 'editor', 'admin'].map(r => (
              <button key={r} onClick={() => setRole(r)} style={{
                flex: 1, padding: '10px 8px', fontSize: 12, textTransform: 'lowercase',
                background: 'none', borderRadius: 0,
                border: `1px solid ${role === r ? theme.accent : theme.borderMedium}`,
                color: role === r ? theme.accent : theme.textMuted,
                cursor: 'pointer', fontFamily: 'inherit',
              }}>
                <div>{ROLE_LABELS[r]}</div>
                <div style={{ fontSize: 10, marginTop: 2, opacity: 0.7 }}>
                  {r === 'viewer' && 'browse only'}
                  {r === 'editor' && 'upload & edit'}
                  {r === 'admin' && 'full access'}
                </div>
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex' }}>
          <button onClick={onClose} style={{ flex: 1, height: 42, background: 'transparent', border: `1px solid ${theme.borderMedium}`, color: theme.text, fontSize: 13, textTransform: 'lowercase', cursor: 'pointer', fontFamily: 'inherit' }}>cancel</button>
          <button onClick={handleInvite} disabled={inviting} style={{
            flex: 1, height: 42, fontSize: 13, textTransform: 'lowercase',
            background: inviting ? theme.bgInput : theme.fill,
            border: 'none', color: inviting ? theme.textMuted : theme.fillFg,
            cursor: inviting ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
          }}>{inviting ? 'inviting…' : 'send invite'}</button>
        </div>
      </div>
    </div>
  );
}
